export enum TypesError {
  MAX = "max",
  MIN = "min",
  ISHUNDREDTH = "isHundredth",
}
